import { render, staticRenderFns } from "./AddStrategy.vue?vue&type=template&id=fad658f8&"
import script from "./AddStrategy.vue?vue&type=script&lang=js&"
export * from "./AddStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports